<template>
  <button type="submit" class="note_button" @click="handleConfirm">
    <span>{{ buttonText }}</span>
  </button>
</template>

<script>
export default {
  props: {
    buttonText: String,
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  color: #fff;
  background-color: #2eb85c;
  border-color: #2eb85c;
  width: 50%;
  padding: 5px 10px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  border: none;
}
</style>
